/**
 * Shared route helpers for Workspace / Executive / Partner portals.
 */

export const PORTAL_LABELS = {
  overview: "Overview",
  kiosk: "Kiosk",
  skin: "Skin analysis",
  catalog: "Catalog",
  store: "Store",
  network: "Network",
  insights: "Insights",
  access: "Access",
  organization: "Organization",
  about: "About",
};

export const BREADCRUMB_LABELS = {
  overview: "Overview",
  dashboard: "Dashboard",
  "ib-dashboard": "Dashboard",
  "check-ins": "Check-ins",
  productlist: "Product list",
  "add-product": "Add Product",
  "edit-product": "Edit Product",
  "view-product": "View Product",
  users: "Users",
  organization: "Company Profile",
  "company-profile": "Company Profile",
  "edit-profile": "Edit Profile",
  settings: "Settings",
  "page-setup": "Page Setup",
  "skin-analysis-settings": "Skin Analysis Settings",
};

export function buildBreadcrumbParentMap(portalBasePath) {
  return {
    [`${portalBasePath}/add-product`]: `${portalBasePath}/productlist`,
    [`${portalBasePath}/edit-product`]: `${portalBasePath}/productlist`,
    [`${portalBasePath}/view-product`]: `${portalBasePath}/productlist`,
    [`${portalBasePath}/product/`]: `${portalBasePath}/productlist`,
    [`${portalBasePath}/add-service`]: `${portalBasePath}/servicelist`,
    [`${portalBasePath}/edit-service`]: `${portalBasePath}/servicelist`,
    [`${portalBasePath}/view-service`]: `${portalBasePath}/servicelist`,
    [`${portalBasePath}/service/`]: `${portalBasePath}/servicelist`,
  };
}

export function authStorageKeys(portalId) {
  const id = portalId || "naturals_head";
  return {
    token: `naturals_${id}_AUTH_TOKEN`,
    userId: `naturals_${id}_userId`,
    poweredBy: `naturals_${id}_powered_by_nyafaz`,
    dismissedToasts: `naturals_${id}_dismissed_checkin_toasts`,
  };
}

function isCheckinNotification(item) {
  const meta = item?.metadata || {};
  const title = String(item?.title || "").toLowerCase();
  return (
    meta?.type === "checkin" ||
    meta?.type === "service_started" ||
    String(item?.category_key || "").startsWith("checkin:") ||
    title.includes("check-in") ||
    title.includes("service started")
  );
}

function isOrderNotification(item) {
  const meta = item?.metadata || {};
  const key = String(item?.category_key || "");
  const title = String(item?.title || "").toLowerCase();
  return (
    meta?.type === "order" ||
    key.startsWith("salon-order:") ||
    title.includes("order placed")
  );
}

function isLocationNotification(item) {
  const meta = item?.metadata || {};
  const key = String(item?.category_key || "");
  const title = String(item?.title || "").toLowerCase();
  return (
    meta?.type === "location_request" ||
    meta?.type === "location_request_decision" ||
    key.startsWith("loc-req") ||
    title.includes("location change") ||
    title.includes("location approved") ||
    title.includes("location rejected")
  );
}

export function notificationHref(item, portalBasePath) {
  const meta = item?.metadata || {};
  if (typeof meta.link === "string" && meta.link.startsWith("/")) return meta.link;
  if (isOrderNotification(item)) return `${portalBasePath}/my-orders`;
  if (isLocationNotification(item)) {
    if (portalBasePath === "/enterprise/workspace") {
      return `${portalBasePath}/store-location-requests`;
    }
    if (portalBasePath === "/enterprise/partner") {
      return `${portalBasePath}/store-location`;
    }
    return "";
  }
  if (isCheckinNotification(item)) return `${portalBasePath}/check-ins`;
  return "";
}

export function getViewportBucket() {
  if (typeof window === "undefined") return "desktop";
  const width = window.innerWidth;
  if (width < 768) return "mobile";
  if (width < 1367) return "tablet";
  return "desktop";
}
